
const SpecialSymbolStrip = (val) =>
    // Accept letters, apostrophes and whitespace only.
    val?.replace(/[^A-Za-z' ]/gi, '');

export default SpecialSymbolStrip;